/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignAddonDestroy } from '../../axios/campaignAddonDestroy'
import type {
	CampaignAddonDestroyError,
	CampaignAddonDestroyPathParams,
	CampaignAddonDestroyResponse,
} from '../../types/CampaignAddonDestroy'

export const campaignAddonDestroyMutationKey = () => [{ url: '/campaigns/:campaign/addon/:addon' }] as const

export type CampaignAddonDestroyMutationKey = ReturnType<typeof campaignAddonDestroyMutationKey>

export type CampaignAddonDestroyVariables = {
	campaign: CampaignAddonDestroyPathParams['campaign']
	addon: CampaignAddonDestroyPathParams['addon']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAddonController.php CampaignAddonController::destroy */
export function useCampaignAddonDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignAddonDestroyResponse,
		AxiosError<CampaignAddonDestroyError>,
		CampaignAddonDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignAddonDestroyMutationKey(),
		mutationFn: ({ campaign, addon }: CampaignAddonDestroyVariables) =>
			campaignAddonDestroy(campaign, addon, config).then(res => res.data),
		...options,
	})
}
